import { render, staticRenderFns } from "./EzUserModal.vue?vue&type=template&id=7879fde6&scoped=true&"
import script from "./EzUserModal.vue?vue&type=script&lang=js&"
export * from "./EzUserModal.vue?vue&type=script&lang=js&"
import style0 from "./EzUserModal.vue?vue&type=style&index=0&id=7879fde6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7879fde6",
  null
  
)

export default component.exports